import { asyncRoutes, constantRouterMap, resetRouter } from '@/router'
import { userMenu, userPerms } from '@/api/user'
// import { FinancialRouter } from '@/router/modules/financial'
import administratorRouter from '@/router/modules/administration'
import cookie from 'vue-cookies'
// 将本地asyncRoutes映射到ajax获取到的serverRouterMap;
function generateAsyncRouter (asyncRoutes, serverRouterMap) {
  var res = []
  serverRouterMap.forEach(function (item1, index) {
    if (asyncRoutes) {
      asyncRoutes.forEach(function (item2) {
        if (item1.text.includes(item2.meta.title)) {
          if (item1.children.length === 0) {
            if (item2.meta.alwaysShow) {
              // 针对单个的
              res.push({
                path: item2.path,
                component: item2.component,
                meta: item2.meta,
                children: item2.children
              })
            } else {
              res.push({
                path: item2.path,
                name: item2.name,
                component: item2.component,
                meta: item2.meta
              })
            }
          } else {
            res.push({
              path: item2.path,
              component: item2.component,
              redirect: item2.redirect,
              meta: item2.meta,
              alwaysShow: !!item1.children,
              children: childrens(item2.children, item1.children)
            })
          }
        }
      })
    }
  })
  return res
}
// 处理子元素匹配
function childrens (ite, item) {
  if (item && item.length > 0) {
    const arr = generateAsyncRouter(ite, item)
    return arr
  }
}

function handleRouters (asyncRoutes, serverRouterMap) {
  let routes = generateAsyncRouter(asyncRoutes, serverRouterMap)
  routes.forEach(item1 => {
    asyncRoutes.forEach(item2 => {
      if (item1.path == item2.path && item2.meta.title == 'desc') {
        if (item1.children) {
          item1.children = item1.children.concat(item2.children)
        }
      }
    })
  })
  return routes
}

const state = {
  loadmenu: [], // 菜单栏
  addRouters: [], // 保存的菜单栏
  tagsView: false, // 用来处理是那端
  isActive: false, // 用来处理显示
  userPerms: cookie.get('perms') || {} // 用来处理按钮的操作
}

const mutations = {
  SET_LOADMENU: (state, loadmenu) => {
    state.addRouters = loadmenu
    state.loadmenu = constantRouterMap.concat(loadmenu)
  },
  SET_TAGVIEW: (state, tagsView) => {
    // 当第一次进入的时候需要判断的
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (width <= 1000) {
      state.tagsView = false
    } else {
      state.tagsView = true
    }
    // 动态改变的时候
    var timer = null
    window.addEventListener('resize', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        if (width <= 1000) {
          state.tagsView = false
        } else {
          state.tagsView = true
        }
      }, 400)
    })
  },
  SET_ISACTIVE: (state, isActive) => {
    if (state.tagsView) {
      state.isActive = true
    } else {
      state.isActive = isActive
    }
  },
  SET_USERPERMS: (state, userPerms) => {
    state.userPerms = userPerms
  }
}
const actions = {
  // 菜单栏显示
  Loadmenu ({ commit, state }) {
    return new Promise((resolve, reject) => {
      userMenu().then(res => {
        var accessedRoutes = handleRouters(asyncRoutes, res.data)
        // 在这里最后添加404
        // 先静态处理下位置信息
        // accessedRoutes.splice(2, 0, administratorRouter)
        // accessedRoutes.splice(3, 0, FinancialRouter)
        // accessedRoutes.push(MonthlyRouter,RulesRegRouter,{ path: '*', redirect: '/404', hidden: true, meta: { title: '404' }})
        let logsRouter = {
          path: '/logs',
          component: () => import('@/views/layout'),
          redirect: '/logs/index',
          children: [
            {
              path: 'index',
              name: 'logs',
              meta: { title: '更新日志', icon: require('@/assets/slider/log.png'), nostyle: true },
              component: () => import('@/views/logs/index')
            }
          ]
        }
        accessedRoutes.push(logsRouter)
        accessedRoutes.push({ path: '*', redirect: '/404', hidden: true, meta: { title: '404' } })
        commit('SET_LOADMENU', accessedRoutes)
        resetRouter()
        resolve(accessedRoutes)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 处理按钮操作
  loadperms ({ commit, state }) {
    return new Promise((resolve, reject) => {
      userPerms().then(res => {
        // // 拿到的数组进行循环，把其中的子元素拿出来
        let data = res.data
        var staffList1, staffList2, staffList3, projectList1, projectList2,
          projectList3, projectList4, projectList5, projectList6, projectList7,
          projectList8, projectList9, projectList10, politicsList1, rolesList1, rolesList2,
          rolesList3, rolesList4, rolesList5, systemList1, systemList2, systemList3,
          systemList4, systemList5, systemList6, finance1, finance2, finance3, finance4,
          statistical1
        finance1 = {
          审批工资: false,
          导入: false,
          编辑: false,
          重置工资表: false
        }
        data.forEach(item => {
          if (item.text == '员工管理') {
            staffList1 = filterPerams(item.children, '员工列表')
            staffList2 = filterPerams(item.children, '离职列表')
            staffList3 = filterPerams(item.children, '办公室人员')
          }
          if (item.text == '项目管理') {
            projectList1 = filterPerams(item.children, '项目列表')
            projectList2 = filterPerams(item.children, '项目位置')
            projectList3 = filterPerams(item.children, '队员列表')
            projectList4 = filterPerams(item.children, '立项')
            projectList5 = filterPerams(item.children, '进程')
            projectList6 = filterPerams(item.children, '派遣单审核')
            projectList7 = filterPerams(item.children, '考勤')
            projectList8 = filterPerams(item.children, '成本核算')
            projectList9 = filterPerams(item.children, '巡逻打卡')
			      projectList10 = filterPerams(item.children, '表扬投诉')
          }
          if (item.text == '行政管理') {
            politicsList1 = filterPerams(item.children, '采购')
          }
          if (item.text == '权限管理') {
            rolesList1 = filterPerams(item.children, '公司管理')
            rolesList2 = filterPerams(item.children, '用户管理')
            rolesList3 = filterPerams(item.children, '角色管理')
            rolesList4 = filterPerams(item.children, '合同公司')
            rolesList5 = filterPerams(item.children, '客户管理')
          }
          if (item.text == '办公管理') {
            item.children.forEach(child => {
              if (child.children) {
                if (child.text === '档案管理') {
                  child.children.forEach(code => {
                    if (code.text === '规章制度') {
                      systemList1 = filterPerams(code.children, '总则')
                      systemList2 = filterPerams(code.children, '行政人事')
                      systemList3 = filterPerams(code.children, '财务')
                      systemList4 = filterPerams(code.children, '市场')
                      systemList5 = filterPerams(code.children, '运营')
                    }
                  })
                }
              }
            })
          }
          if (item.text === '财务管理') {
            finance1 = filterPerams(item.children, '工资')
            finance2 = filterPerams(item.children, '服务费管理')
          }
          if (item.text === '统计分析') {
            statistical1 = filterPerams(item.children, '报表')
          }
        })
        var obj = {
          staffList1,
          staffList2,
          staffList3,
          projectList1,
          projectList2,
          projectList3,
          projectList4,
          projectList5,
          projectList6,
          projectList7,
          projectList8,
          projectList9,
		  projectList10,
          politicsList1,
          rolesList1,
          rolesList2,
          rolesList3,
          rolesList4,
          rolesList5,
          systemList1,
          systemList2,
          systemList3,
          systemList4,
          systemList5,
          finance2,
          finance1,
          statistical1
        }
        commit('SET_USERPERMS', obj)
        cookie.set('perms', obj)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }

}
// 处理按钮操作 处理成数组，如果存在就当键值
export function filterPerams (data, str) {
  let obj = {}
  data.forEach(item => {
    if (item.text == str) {
      if (item.children.length > 0) {
        item.children.forEach(item2 => {
          if (item2.text) {
            obj[item2['text']] = true
          }
        })
      } else {
        obj = {}
      }
    }
  })
  return obj
}

export default {
  // namespaced: true, // 命名作用域
  state,
  mutations,
  actions
}
